export default __webpack_public_path__ + "50e9c60f1499adc8ebc877a09494ffbb.png";